import styled from 'styled-components';
import { SectionSubHead } from './SectionSubHead.styled';

const ReportSummarySubHead = styled(SectionSubHead)`
  display: grid;
  grid-template-columns: calc(32vw - 2rem) 1fr;
  grid-column-gap: ${(props): string => props.theme.spaces.xl};
`;

export { ReportSummarySubHead };
